import { InstrumentTypeResponse } from "../codegen-api";
import { getRouteSegmentForInstrument, TRADING_TYPE_LIST } from "../config/features";
import { AssetResponse } from "../utils/asset";
import { getAssetShortName } from "../utils/asset/assets";

export enum TradingRoutePathParamsEnum {
  DERIVATIVE = "derivative",
  ASSET = "asset",
  INSTRUMENT_NAME = "instrument",
}

// Trading URLs are `/{segment}/{asset}/{instrument}` where `{segment}` is a
// KNOWN trading vertical (perpetual, spot, option, ...), never an open param.
//
// An open `/:derivative/:asset/:instrument/` pattern outranks static splat
// pages like `/portfolio/*` in React Router v6 (3 dynamic segments score higher
// than a static prefix + splat), so `/portfolio/positions/orders` would mount
// the Trading page. Pinning the first segment to the registry's route segments
// keeps reserved page prefixes (portfolio, settings, historical, rfq, ...) from
// ever matching a trading pattern. Disabled verticals are intentionally still
// listed so their URLs resolve and `OutletRoute` can normalise them to the
// default vertical, exactly as before.
export const validTradingRoutes: string[] = [
  "/",
  ...TRADING_TYPE_LIST.flatMap(({ routeSegment }) => [
    `/${routeSegment}/`,
    `/${routeSegment}/:${TradingRoutePathParamsEnum.ASSET}/`,
    `/${routeSegment}/:${TradingRoutePathParamsEnum.ASSET}/:${TradingRoutePathParamsEnum.INSTRUMENT_NAME}/`,
  ]),
];

export const getTradingRoutePath = (
  derivative: InstrumentTypeResponse,
  asset: AssetResponse,
  instrumentName?: string
) => {
  const displayAsset = getAssetShortName(asset) || asset;
  // The URL segment comes from the trading-type registry rather than
  // `derivative.toLowerCase()`, so a vertical whose segment differs from its
  // instrument type still round-trips. Today's segments are unchanged.
  const segment = getRouteSegmentForInstrument(derivative);
  let newPath = `/${segment}/${(displayAsset).toLowerCase()}`;
  if (instrumentName) {
    newPath += `/${instrumentName.toUpperCase()}`;
  }
  return newPath;
};
